import StepperProvider, {
	StepperContext,
	IStepperContext
} from './StepperProvider';

export type { IStepperContext };
export { StepperContext };
export default StepperProvider;
